import type { Router, RouteLocationNormalized } from 'vue-router';
import { getMetrics } from './metrics';
import { ErrorLocation, reportClientError } from './errors';

const startTimestamps = new WeakMap<RouteLocationNormalized, number>();

export function installRouterTiming(router: Router): void {
  router.beforeEach((to, _from, next) => {
    try {
      startTimestamps.set(to, performance.now());
    } catch (err) {
      reportClientError(err, ErrorLocation.RouterTimingFailed);
    }
    next();
  });

  router.afterEach(to => {
    try {
      const start = startTimestamps.get(to);
      if (typeof start !== 'number') return;
      startTimestamps.delete(to);
      getMetrics().spaRouteChangeDurationMs.record(performance.now() - start, {
        to_path: to.path,
      });
    } catch (err) {
      reportClientError(err, ErrorLocation.RouterTimingFailed);
    }
  });
}
